import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Viewer } from "../../../../../widgets/Viewer";
import { withRouter } from 'react-router-dom';
import { Spinner } from '@blueprintjs/core';

import { loadReportCards, deleteReportCard } from '../../../../../../redux/actions/reportCard.actions';

const ReportCardRow = props => {
    return (
        <tr onClick={() => props.editRow(props.reportCard)}>
            <td>{moment(props.reportCard.date_written).format('ddd, MMM Do, YYYY')}</td>
            <td onClick={e => e.stopPropagation()}>
                <Viewer src={props.reportCard.image || props.reportCard.dropbox_image_share_url || ''} style={{ height: '30px' }} thumbnail />
            </td>
            <td className="action-row">
                <div className="pt-button pt-intent-danger pt-icon-trash pt-small" onClick={(event) => props.deleteRow({ reportCard: props.reportCard, event })}>Delete</div>
            </td>
        </tr>
    );
};

class ReportCards extends Component {
    async componentDidMount() {
        const { clientId, progressId } = this.props.match.params;
        await this.props.loadReportCards({ recipientId: clientId, progressId });
    }
    openReportCardsModal = () => {
        const event = new CustomEvent('open-report-card-modal', {
            detail: {
                ...this.props.match.params,
                recipientId: this.props.match.params.clientId
            }
        });
        window.dispatchEvent(event);
    }
    editRow = (reportCard) => {
        const { clientId, progressId } = this.props.match.params;
        const event = new CustomEvent('open-report-card-modal', {
            detail: {
                ...reportCard,
                recipientId: clientId,
                progressId
            }
        });
        window.dispatchEvent(event);
    }
    deleteRow = ({ event, reportCard }) => {
        event.preventDefault();
        event.stopPropagation();
        const { clientId, progressId } = this.props.match.params;
        const customEvent = new CustomEvent('open-delete-modal', {
            detail: {
                content: `Are you sure you want to delete this report card?`,
                onDelete: () => {
                    this.props.deleteReportCard({ recipientId: clientId, progressId, reportCardId: reportCard.id });
                }
            }
        });
        window.dispatchEvent(customEvent);
    }
    render() {
        const { reportCards } = this.props;
        return (
            <div className="panel-reportCards panel-content">
                { this.props.allLoading ?
                    <div className="spinner-container">
                        <Spinner large />
                    </div> :
                    reportCards.length ?
                        <table className="general-table pt-html-table pt-interactive">
                            <thead>
                                <tr>
                                    <th>Date Written</th>
                                    <th>Preview</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                { reportCards.map((reportCard, i) => (
                                    <ReportCardRow key={i}
                                        reportCard={reportCard}
                                        editRow={this.editRow}
                                        deleteRow={this.deleteRow} />
                                ))}
                            </tbody>
                        </table> :
                        <div className="intro">
                            <div className="intro-text">
                                No report cards. Start by <span className="link" onClick={this.openReportCardsModal} >adding one</span>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    reportCards: state.reportCard.reportCards,
    reportCardsById: state.reportCard.reportCardsById,
    allLoading: state.reportCard.allLoading
});

const mapDispatchToProps = {
    loadReportCards,
    deleteReportCard
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportCards));


// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/recipient/progress-panels/ReportCards.jsx